// extracted by mini-css-extract-plugin
export default {"buttonContainer":"PmaxDrawerFooter_buttonContainer__4b-md","drawerActionsContainer":"PmaxDrawerFooter_drawerActionsContainer__RZWPe"};